import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { sec } from "../../../security";
import {
  AttorneyDownloadError,
  AttorneyDownloadRequest,
  AttorneyDownloadResponse
} from "./model/attorneyDownload";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const attorneyDownloadsApi = createApi({
  reducerPath: "attorneyDownloadsV2",
  tagTypes: ["AttorneyDownloads"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    downloadAttorneys: builder.mutation<
      AttorneyDownloadResponse,
      AttorneyDownloadRequest
    >({
      query: (body) => ({
        url: "/api/v2/attorney_downloads/download",
        method: "POST",
        body
      }),
      transformErrorResponse: (response: any): AttorneyDownloadError => {
        return {
          error:
            response.data?.error || response.statusText || "An error occurred"
        };
      }
    })
  })
});

// Export hooks for usage in functional components
export const { useDownloadAttorneysMutation } = attorneyDownloadsApi;
